import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid } from "@material-ui/core";
import {
  SimpleLoading,
  PromotionalFooterPure,
  ButtonAddHLPure,
} from "../../pures";
import {
  HeaderHLPure,
  ButtonHLPure,
  FilterHLPure,
  GridHLPure,
  SearchBarHLPure,
  DialogYesNoHLPure,
  DialogSystemGLPure,
  DropDownBtnHLPure,
  LabelModalPure,
} from "../../pures";
import "./user-administration.view.css";
import UserAdministrationConfigurationsView from "./user-administration-pages/user-administration-configurations.view";
import useMediaQuery from '@material-ui/core/useMediaQuery'

const UserAdministrationView = (props) => {
  const {
    usersCollaboratorAdmin,
    optionsFilter,
    rolesBySignatureProfile,
    deleteUser,
    handleCloseDialogDelete,
    showDialogDelete,
    handleShowDialogDelete,
  } = props;
  const { t } = useTranslation();
  const [dataUser, setDataUser] = useState(usersCollaboratorAdmin);
  const [selectedValueFilter, setSelectedValue] = useState(
    t("userAdministrationView.status.all")
  );
  const [searchValue, setSearchValue] = useState("");
  const [selectedUser, setSelectedUser] = useState({});
  const [showDetails, setShowDetails] = useState(false);
  const [nameComponentUser, setNameComponentUser] = useState("");
  const [headerTitleinDetail, setHeaderTitleinDetail] = useState({
    clicked: false,
    name: "",
  });

  const isMobile = useMediaQuery('(max-width:1025px)')
  const isMobileHorizontal = useMediaQuery('(max-width:1200px) and (orientation: landscape)')
  const isCompactView = isMobile || isMobileHorizontal

  //Filter Function, convert to boolean
  const strToboolean = (value) => {
    if (value && typeof value === "string") {
      if (value === t("userAdministrationView.status.active")) return true;
      if (value === t("userAdministrationView.status.inactive")) return false;
    }
    return value;
  };

  //Filter Function, get selected value
  const filterChange = (e) => {
    const selectedOption = strToboolean(e.target.value);
    setSelectedValue(selectedOption);
  };

  //Update state information from grid
  useEffect(() => {
    setDataUser(usersCollaboratorAdmin);
  }, [usersCollaboratorAdmin]);

  // //Filter Function, filter elements and update grid
  useEffect(() => {
    let usersCopy = [...usersCollaboratorAdmin];
    let dataUpadate = usersCopy.filter(
      (user) => user.active === selectedValueFilter
    );
    setDataUser(dataUpadate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValueFilter]);

  //Search Function, get value search input
  const searchChange = (e) => {
    e.preventDefault();
    setSearchValue(e.target.value);
  };

  //Search Function, search elements and update grid
  useEffect(() => {
    let usersCopy = [...usersCollaboratorAdmin];
    let dataUpdateFilter =
      selectedValueFilter === t("userAdministrationView.status.all")
        ? usersCollaboratorAdmin
        : usersCopy.filter((client) => client.active === selectedValueFilter);

    let dataUpadateSearch = dataUpdateFilter.filter((user) => {
      return (
        user.name.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0 ||
        user.email.indexOf(searchValue.toLowerCase()) >= 0
      );
    });
    setDataUser(dataUpadateSearch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, selectedValueFilter]);

  const setHeaderTitle = () => {
    const name = headerTitleinDetail.name || nameComponentUser;
    switch (name) {
      case "":
        return t("userAdministrationView.title");
      case t("userAdministrationView.grid.actions.assign.roles"):
        return t("userAdministrationView.roleAssignTitle");
      case t("userAdministrationView.grid.actions.assign.companies"):
        return t("userAdministrationView.enterpriseAssignTitle");
      case t("userAdministrationView.grid.actions.disable"):
        return t("userAdministrationView.disableUserTitle");
      case "Agregar usuario":
        return t("userAdministrationView.saveUserTitle");
      default:
        return t("userAdministrationView.title");
    }
  };

  useEffect(() => {
    if (headerTitleinDetail.clicked) {
      setHeaderTitle();
    }
    setHeaderTitle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameComponentUser, headerTitleinDetail]);

  return (
    <div className="standard-wrapper">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Container
          lg={12}
          md={12}
          spacing={4}
          className="userAdministrationView-container"
        >
          {showDetails && nameComponentUser ? (
            <UserAdministrationConfigurationsView
              nameComponentUser={nameComponentUser}
              selectedUser={selectedUser}
              hideShowDetails={() => {
                setShowDetails(false);
                setNameComponentUser("");
                setHeaderTitleinDetail({ clicked: false, name: "" });
              }}
              userAdmin={props?.user?.userMetaData?.userMifirma?.email}
              token={props.token}
              rolesBySignatureProfile={rolesBySignatureProfile}
              setHeaderTitleinDetail={setHeaderTitleinDetail}
              validators={props.validators}
              forceRefresh={props.forceRefresh}
              setShowDetails={setShowDetails}
              usersCollaboratorAdmin={usersCollaboratorAdmin}
              showErrorRequesting={props.showErrorRequesting}
              showLoadingRequesting={props.showLoadingRequesting}
              showCompletedRequesting={props.showCompletedRequesting}
              showWarningRequesting={props.showWarningRequesting}
              toggleWarningRequesting={props.toggleWarningRequesting}
              toggleLoadingRequesting={props.toggleLoadingRequesting}
              toggleCompletedRequesting={props.toggleCompletedRequesting}
              toggleErrorRequesting={props.toggleErrorRequesting}
              setNameComponentUser={setNameComponentUser}
              message={props.message}
              t={t}
              {...props}
            />
          ) : (
            <>
              {/**HEADER Container**/}
              <Grid
                item
                lg={12}
                md={12}
                xs={12}
                sm={12}
                className="userAdministrationView-header"
              >
                <HeaderHLPure title={t("userAdministrationView.title")} />
              </Grid>
              <div className='userAdministrationView-navbar'>
                <div className='userAdministrationView-buttonHLPure'>
                  <ButtonAddHLPure
                    nameBtn={t('userAdministrationView.buttonTitle')}
                    iconAdd
                    onClickBtn={() => {
                      setNameComponentUser('Agregar usuario')
                      setShowDetails(true);
                    }}
                  />
                </div>
                <div className='userAdministrationView-searchHLPure'>
                  <SearchBarHLPure
                    placeholder={t(
                      'userAdministrationView.searchBarPlaceHolder'
                    )}
                    onSearchChange={(e) => searchChange(e)}
                  />
                </div>
                <div className='userAdministrationView-filterHLPure'>
                  <DropDownBtnHLPure
                    optionsDropDown={optionsFilter}
                    nameOption={'status'}
                    valueItem={'todos'}
                    optionsValue={'todos'}
                    onDropDownChange={(e) => filterChange(e)}
                    iconFilter={true}
                  />
                </div>
              </div>

              <Grid item className="userAdministrationView-gridContainer">
                <GridHLPure
                  {...props}
                  dataGrid={dataUser}
                  skip={0}
                  take={6}
                  selectedValueFilter={selectedValueFilter}
                  titleRow1={t("userAdministrationView.grid.title.1")}
                  fieldRow1={"name"}
                  fieldTitle={"name"}
                  // titleRow2={"Acciones"}
                  fieldSubtitle={"email"}
                  fieldImg={"profilePicture"}
                  onFilterChange={filterChange}
                  onSelectedItem={setSelectedUser}
                  setShowDetails={setShowDetails}
                  setNameComponentUser={setNameComponentUser}
                  filter={true}
                  column2Status
                  field2Status={"active"}
                  title2Status={!isCompactView ? t('userAdministrationView.grid.title.2') : null}
                  columnThree={false}
                  iconColumnThree={false}
                  iconActiveThree={false}
                  columnFour={true}
                  titleRow4={t("userAdministrationView.grid.title.3")}
                  iconOneActive
                  iconTwoActive
                  iconThirdActive
                  iconFourthActive
                  activeDialogTrash
                  labelOneActions={t(
                    "userAdministrationView.grid.actions.assign.roles"
                  )}
                  labelTwoActions={t(
                    "userAdministrationView.grid.actions.assign.companies"
                  )}
                  labelThirdActions={t(
                    "userAdministrationView.grid.actions.disable"
                  )}
                  labelFourthActions={t(
                    "userAdministrationView.grid.actions.view.detail"
                  )}
                  styleCol1={"userAdministrationView-cellItemStylesCol1"}
                  styleCol2={"userAdministrationView-cellItemStylesCol2"}
                  styleCol3={"userAdministrationView-cellItemStylesCol3"}
                  styleCol4={"userAdministrationView-cellItemStylesCol4"}
                  widthHeaderCol1={"userAdministrationView-widthHeaderCol1"}
                  widthHeaderCol2={'userAdministrationView-widthHeaderCol2'}
                  widthHeaderCol3={"userAdministrationView-widthHeaderCol1"}
                  widthHeaderCol4={"userAdministrationView-widthHeaderCol1"}
                  widthHeaderGeneral={
                    "userAdministrationView-widthHeaderGeneral"
                  }
                  iconAvatar
                  btnOpenDialog1={false}
                  activeDialog1={false}
                  btnOpenDialogTrash={(dataItem) =>
                    handleShowDialogDelete(dataItem)
                  }
                />
              </Grid>
            </>
          )}
          {!nameComponentUser && (
            <Grid
              container
              style={{ justifyContent: "flex-end", paddingBottom: "20px" }}
            >
              <ButtonHLPure
                nameBtn={t("button.return")}
                onClickBtn={() => props.history.push("/configuration")}
              />
            </Grid>
          )}
          {showDialogDelete && (
            <DialogYesNoHLPure
              cancel={() => handleCloseDialogDelete()}
              textBtnCancel={t("button.cancel")}
              saveBtn={t("button.delete")}
              titleDialog={t("userAdministrationView.dialog.delete.title")}
              handleSubmit={() => deleteUser()}
            >
              <div className="userAdministrationView-dialog-delete-body">
                <LabelModalPure
                  label={t("userAdministrationView.dialog.delete.question")}
                />
              </div>
            </DialogYesNoHLPure>
          )}
          <Grid item xs={12} lg={12} md={12} sm={12}>
            <PromotionalFooterPure />
          </Grid>
        </Container>
      )}
    </div>
  );
};

export default UserAdministrationView;
